export default "__VITE_ASSET__xJDFdPqJ__"